import { SEGMENTS } from "../../constants/segments";

export const SegmentTabs = ({ activeSegment, onChange, segments = SEGMENTS }) => {
  return (
    <div data-testid="segment-tabs" className="flex items-center gap-1 rounded-lg border border-white/10 bg-eb-elevated p-1">
      {segments.map((segment) => {
        const active = segment.key === activeSegment;
        return (
          <button
            key={segment.key}
            data-testid={`segment-tab-${segment.key.toLowerCase()}`}
            onClick={() => onChange(segment.key)}
            aria-pressed={active}
            className={`rounded-md px-4 py-1.5 font-heading text-xs uppercase tracking-wide transition-all ${
              active ? "bg-eb-accent text-white shadow-[0_0_0_1px_rgba(0,122,255,0.5)]" : "text-zinc-500 hover:text-zinc-200"
            }`}
          >
            <span className="whitespace-pre">{segment.label}</span>
          </button>
        );
      })}
    </div>
  );
};
